import React from 'react';

import DocumentInput from '../../UserDataFields/DocumentInput';

const TestingPaymentMethod = () => {
  return (
    <div className="flex flex-col w-full">
      <h2 className="mb-24 font-h4">TESTEO DE INPUTS</h2>
      <DocumentInput onChange={console.log} />
    </div>
  );
};

export default TestingPaymentMethod;
